export default "__VITE_ASSET__BylUk$a1__"